import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {onMounted, onUnmounted, watch} from "vue";
import FiltersDropdownsList from '@/components/SerpPage/FiltersContainer/FiltersList/FiltersDropdownsList.vue'
import FiltersHeaderContainer from '@/components/SerpPage/FiltersContainer/Header/FiltersHeaderContainer.vue'
import CloseButton from "@/components/SerpPage/FiltersContainer/Header/CloseButton.vue";
import ComponentLoader from '@/components/ComponentLoader.vue'


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersContainerTop',
  setup(__props) {

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {canShowFiltersOnMobile, isLoading} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)


watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});

onMounted(() => {
  filtersStore.fetchFilters();
  window.addEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});

onUnmounted(() => {
  window.removeEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});


return (_ctx: any,_cache: any) => {
  return (!_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{
       'q-d-block': _unref(canShowFiltersOnMobile),
       'q-d-none': !_unref(canShowFiltersOnMobile),
       'serp__filters--mobile q-position-fixed q-top-0 q-left-0 q-bottom-0 q-right-0 q-w-100 q-h-100  q-d-none q-md-block': _unref(canShowFiltersOnMobile) && _unref(isMobileView)
       }, "serp__filters-container filters-container-top q-container-xxl q-pt-lg-3 q-d-flex q-col-12 q-d-md-block q-py-3 q-py-md-1 q-position-relative"])
      }, [
        (_unref(canShowFiltersOnMobile) && _unref(isMobileView))
          ? (_openBlock(), _createBlock(ComponentLoader, {
              key: 0,
              loading: _unref(isLoading)
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(CloseButton),
        (_unref(canShowFiltersOnMobile) && _unref(isMobileView))
          ? (_openBlock(), _createBlock(FiltersHeaderContainer, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(FiltersDropdownsList)
      ], 2))
    : _createCommentVNode("", true)
}
}

})